import { MainMenuObject } from 'features/menu/components/menu-tile-grid/menu-tile/types';
import { pinTargetItems } from 'features/menu/utils/pin-target-items';

/**
 * Re-inserts deeplink targets that exist in the Sanity section options but were
 * filtered out for store availability, then pins them for unavailable chrome.
 */
export function injectAndPinLegacyUnavailableSectionItems(
  availableItems: MainMenuObject[],
  sectionOptions: MainMenuObject[],
  targetItemIds: string[]
): { items: MainMenuObject[]; injectedIds: string[] } {
  if (!targetItemIds.length) {
    return { items: availableItems, injectedIds: [] };
  }

  const availableIds = new Set(availableItems.map(item => item._id));
  const injected: MainMenuObject[] = [];
  const injectedIds: string[] = [];

  for (const id of targetItemIds) {
    if (!id || availableIds.has(id)) {
      continue;
    }
    const fromSection = sectionOptions.find(option => option._id === id);
    if (!fromSection) {
      continue;
    }
    injected.push(fromSection);
    injectedIds.push(id);
    availableIds.add(id);
  }

  if (!injected.length) {
    return {
      items: pinTargetItems(availableItems, targetItemIds),
      injectedIds: [],
    };
  }

  return {
    items: pinTargetItems([...injected, ...availableItems], targetItemIds),
    injectedIds,
  };
}
